// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1282":"7b784a4451d6ecae6c75","2888":"b216049c17f1a7e25d3e","4585":"8227e12ccf15ae6a948a","7606":"ce0e7014605e082fd26d"}[chunkId] + ".css";
};